export default __webpack_public_path__ + "static/logo-88bd20fc9094fcd4ca34b1e671eab82c.svg";